import React from "react";
import add from "assets/add.svg";

interface CadreDesoummissionsProps {
  couleur: string;
  titre: string;
  sousTitre: string;
}

const CadreDesoummissions = ({
  couleur,
  titre,
  sousTitre,
}: CadreDesoummissionsProps) => {
  return (
    <div className={`w-75 h-45 rounded-lg ${couleur} items-center`}>
      <div className={`flex flex-col justify-center space-y-3`}>
        {/* Remplacer Add2 par l'image importée */}
        <img src={add} alt="Add2" className="w-8 h-8 self-center mt-2" />
        {/* Titre et sous-titre */}
        <div
          className={`Titre text-white text-base font-semibold break-words text-center`}
        >
          {titre}
        </div>
        <div
          className={`SousTrite text-white text-sm font-light break-words text-center`}
        >
          {sousTitre}
        </div>
      </div>
    </div>
  );
};

export default CadreDesoummissions;
